import { render, staticRenderFns } from "./VisitServiceAdd.vue?vue&type=template&id=2a78361c&scoped=true"
import script from "./VisitServiceAdd.vue?vue&type=script&lang=js"
export * from "./VisitServiceAdd.vue?vue&type=script&lang=js"
import style0 from "./VisitServiceAdd.vue?vue&type=style&index=0&id=2a78361c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a78361c",
  null
  
)

export default component.exports